import assert from 'assert-ts';
import dayjs from 'dayjs';
import {getDateString} from './getDateString';

export const getDatesInPeriod = (
  fromDate: Date | string | dayjs.Dayjs,
  toDate: Date | string | dayjs.Dayjs,
): string[] => {
  const dFrom = dayjs(fromDate);
  const dTo = dayjs(toDate);

  assert(
    dFrom.isSame(dTo) || dFrom.isBefore(dTo),
    'getDatesInPeriod: fromDate must be same or before toDate',
    {fromDate, toDate},
  );

  const diff = dTo.diff(dFrom, 'days');
  return [...Array(diff + 1)].map((_, idx) =>
    getDateString(dFrom.add(idx, 'days')),
  );
};
